const BREVO_API_URL = 'https://api.brevo.com/v3/smtp/email';

// Notification types
export const NOTIFICATION_TYPES = {
  FAVORITE_ADDED: 'FAVORITE_ADDED',
  FAVORITE_REMOVED: 'FAVORITE_REMOVED',
};

// Update environment variable access
const config = {
  apiKey: process.env.REACT_APP_BREVO_API_KEY,
  senderEmail: process.env.REACT_APP_BREVO_SENDER_EMAIL,
  senderName: process.env.REACT_APP_BREVO_SENDER_NAME,
  adminEmail: process.env.REACT_APP_BREVO_ADMIN_EMAIL
};

// Main notification handler
export const sendAdminNotification = async ({type, listingId, userId, metadata, listing, user}) => {
  try {
    const apiKey = process.env.REACT_APP_BREVO_API_KEY;
    if (!apiKey) {
      console.error('No API key found in environment variables!');
      throw new Error('API key not configured');
    }

    // Extract user profile data
    const userProfile = user?.attributes?.profile || {};
    const userPublicData = userProfile.publicData || {};
    const userEmail = user?.attributes?.email || userProfile.email || 'Not provided';

    // Map the fields from public data
    const licenseType = userPublicData.pub_License || 'Not specified';
    const practiceState = userPublicData.pub_State || 'Not specified';
    const practiceType = Array.isArray(userPublicData.pub_practice_types) 
      ? userPublicData.pub_practice_types.map(type => type.replace(/_/g, ' ')).join(', ')
      : 'Not specified';
    
    // Create listing URL
    const listingUrl = `https://app.npcollaborator.com/l/${listingId}`;

    // Create email subject with user details
    const userName = `${userProfile.firstName || ''} ${userProfile.lastName || ''}`.trim() || 'Unknown User';
    const emailSubject = `New Favorite Added: ${userName}, ${practiceState}, ${practiceType}`;

    const emailData = {
      sender: {
        email: process.env.REACT_APP_BREVO_SENDER_EMAIL,
        name: process.env.REACT_APP_BREVO_SENDER_NAME || 'Marketplace Admin'
      },
      to: [{
        email: process.env.REACT_APP_BREVO_ADMIN_EMAIL
      }],
      subject: emailSubject,
      htmlContent: `
        <h2>New Favorite Activity</h2>
        
        <h3>User Information:</h3>
        <ul>
          <li><strong>Name:</strong> ${userName}</li>
          <li><strong>Email:</strong> ${userEmail}</li>
          <li><strong>License Type:</strong> ${licenseType}</li>
          <li><strong>Practice State:</strong> ${practiceState}</li>
          <li><strong>Practice Type:</strong> ${practiceType}</li>
          <li><strong>User Type:</strong> ${userPublicData.userType || 'Not specified'}</li>
          <li><strong>Controlled Substances:</strong> ${userPublicData.pub_controlled_substances || 'Not specified'}</li>
          <li><strong>Start Date:</strong> ${userPublicData.pub_start_date?.replace(/_/g, ' ') || 'Not specified'}</li>
        </ul>

        <h3>Favorited Listing Details:</h3>
        <ul>
          <li><strong>Listing ID:</strong> ${listingId || 'Unknown'}</li>
          <li><strong>Listing URL:</strong> <a href="${listingUrl}">${listingUrl}</a></li>
        </ul>

        <p><em>Time of favorite: ${new Date().toLocaleString()}</em></p>
      `
    };

    const response = await fetch(BREVO_API_URL, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'api-key': apiKey
      },
      body: JSON.stringify(emailData)
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('Error response:', {
        status: response.status,
        statusText: response.statusText,
        body: errorText
      });
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();

  } catch (error) {
    console.error('Detailed error:', error);
    throw error;
  }
}; 